import { LayoutDashboard, FileBarChart2, TrendingUp, Calendar, Compass } from 'lucide-react'
import { useUIStore } from '@/store'
import type { ModuleName } from '@/types'

const TABS: Array<{
  id: ModuleName
  label: string
  Icon: typeof LayoutDashboard
}> = [
  { id: 'dashboard', label: 'Home', Icon: LayoutDashboard },
  { id: 'registry', label: 'Debts', Icon: FileBarChart2 },
  { id: 'engine', label: 'Strategy', Icon: TrendingUp },
  { id: 'journey', label: 'Freedom', Icon: Compass },
  { id: 'cashflow', label: 'Cash Flow', Icon: Calendar },
]

/**
 * Mobile bottom navigation. Shows on screens narrower than the `md` breakpoint
 * (~768px) and replaces the top tab bar so primary navigation is thumb-reachable.
 *
 * Respects iOS safe-area-inset-bottom so the home indicator doesn't overlap the
 * tappable region. AppShell adds bottom padding to main content so the last
 * section isn't hidden behind this bar.
 */
export function BottomNav() {
  const activeModule = useUIStore((s) => s.activeModule)
  const setActiveModule = useUIStore((s) => s.setActiveModule)

  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-30 bg-slate-950/95 backdrop-blur border-t border-slate-800"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      aria-label="Primary"
    >
      <div className="flex items-stretch justify-around">
        {TABS.map((tab) => {
          const isActive = activeModule === tab.id
          const Icon = tab.Icon
          return (
            <button
              key={tab.id}
              onClick={() => setActiveModule(tab.id)}
              className={[
                'flex-1 flex flex-col items-center gap-0.5 py-2 px-2 transition-colors',
                isActive ? 'text-emerald-400' : 'text-slate-400 hover:text-white',
              ].join(' ')}
              aria-current={isActive ? 'page' : undefined}
            >
              <Icon className="w-5 h-5" />
              <span className="text-[10px] font-medium leading-tight">{tab.label}</span>
            </button>
          )
        })}
      </div>
    </nav>
  )
}
